export const formStatuses = {
  Unassigned: 'b28842d9ad2641338faeead81752dd27',
  InactiveMembers: '70ab0a4e56f14072893c608b830aa6dc',
  TransferOut: 'f05b1160c6e245cd9c5ff2542fe2ccf7',
  ActiveMembers: 'f4f4ee067e3d4ab0b8ede6627e4ab0ac',
  DuesForm: '622be9722edf4de4b2b66e0e40bbeeef',
  NotStarted: '83434fd0ce264fe09a424596823e80f2',
};

export const formStates = {
  LCTreas: 'c15526c2aebb4713865745ad0ae959c7',
  LCPres: '3e0315958276403bbe2697f83e49e434',
  SpdTreas: 'd7da036b82af4f27b221e1754601dd20',
  SpdSec: '188da6218c6e4e329ce2e6b11b1c7a57',
  SpdExec: '718f31ce9ebb45319b5d9862bd56d96a',
  SpdPres: 'fdd32de02b1c45dbacacae67bd439275',
  Completed: 'a035d8b411774ebfadfc8d3ee1d703f2',
};

export const irsStates = {
  LCTreas: 'd8a0127a9fed426492205fabddc6ef7d',
  LCPres: '9b5971f8fd7047958ffc156e4a2efb55',
  SpdTreas: '9fb1ea53c7b44c33acef63a86484f82d',
  Completed: 'd0bfc717b2e64d098a27507345cf267a',
};

export const memberStatuses = {
  Unassigned: '0fac81ac43094fccae6264c6a76f51e7',
  Inactive: 'bbcd1dfce5a449fba82f7d3e131c4a08',
  Active: '2efc683e8d4a4b7bbdb700f27c18ee08',
  Other: '2ae99ae943064a638aa8fb1806e16ce7',
  NoProcessing: 'a8a813a5c5b04470a102791fc6107b15',
};

export const receiptQuestions = {
  question1: 'c2d10e6c39bf4b84b728aa0e6324746e',
  question2: '77bdefb130884ca2af352ca3e80f8ee3',
  subQuestion3: 'eafd00006a064224966088c3b59384f0',
  subQuestion4: '0b530ad12c604169a7b2e36218bf3677',
  question3: '4f19da96a310482ab27cc4c85aa919de',
  question7: '4bab454f0fc04da9baf0592c10016618',
  question8: 'b4b75e42cc724f39a3adf85c6b4d3bcd',
  question9: '27b665b2aead4f2f915339640601d38c',
  question10: '2aa92f4b9d1140e7b4160c0ab4220f08',
};

export const disbursementQuestions = {
  question0: '14f5fd664fb64f80ab2d76c3dd92b9ec',
  question1: '04eacf562cb24a2bad38630a58fe1a2d',
  question2: 'ef17ef2ed43145618c34fcd2f25926d3',
  question3: '58d97ad6560245bdb4eb7d3a64c7a87f',
  question4: 'd64c8ca603e146899f5394bd25f819fa',
  question5: '9b851331d4e54e6485e4036581a80c19',
  subQuestion3: '9b8835fdfbd44ce792332be2bcf446cc',
  subQuestion4: '9716d7bdd8514fb49e94f082afef6c95',
  question6: '7ffbeb17f21140a4b0140787e4ac3821',
  question9: 'c07551a1eccc4168b74f43ee275ac5e0',
  question10: 'b21d13cf442743128759438d57d33e05',
};

export const assetQuestions = {
  question1: 'bb0c5672578c479c854c8e17b00714cf',
  question3: '468289cd36904f109f773fa1327bd153',
  question4: 'a970c5d2f2264c4a88cca4545b7a138d',
  question5: '46987ef3b44f48359032a2f15d3a2d1d',
  question6: '15e5e73ebb9a47398a73ffb3c5f4e47c',
  question7: '67ff33369da145adb77ec5f48fd18120',
};

export const applications = {
  DocumentAdmin: '1318b71740ac4264823f5e1f9d4bb189',
  TrainingAdmin: '511207ced22e452cb9148c26bcbcae61',
  UserManagement: '5632faa767544d41b49307a34a953459',
  AnnualReportAdmin: '6485c3cb78f946b391ab2fd6f894522b',
  ExecAppBar: 'a6bed255bd9e46228b257235b4250aeb',
  SupportAdmin: 'b3e622d7c28841a694baa95deea762d8',
  BetaUser: 'c0e4a6e0f5b94d4c8b9f2d9c3f1f0b0b',
  MessageAdmin: 'b0803d13c9d34e5a9486ae18b0966672',
  MessageApprover: '8dc3dc1ed04a40ba87ba96a71190633c',
  DonationsViewer: 'f23ff148b99549959caade0302c27850',
  FeedbackAdmin: '1e1f1d0977ee4abf8905371bee469a65',
  PermissionsAdmin: '98b4a3f29a994c64b660898aa4b92a58',
  PCE: '5fae9acbe116443694deea4c10a820e6',
  Foundations: 'e86acbadee1b4b34bcc2556706b89b88',
  NewsfeedAdmin: 'a36fc19277ec42a1bceae41ee22c5dca',
  Reports: '6847a95bc8744dc8b6e7eabfbe35803e',
  MarketplaceAdmin: 'e6054dafd25a44f3b0208e06075d11b7',
};

export const projects = {
  Foundations: 'd715cd09d85844039ba4807c991232c2',
  ELF: '134fcb458f1a447fb6854393e4d4ffd3',
  IPS: '2385c3c477c54329b2afbe3a6c7f432b',
  PCE: 'a3329a35021f4db1b9608945f5b501df',
  PSA: 'aa9e8eb796734e2887f3d92fa211f77c',
  STAR: 'f7369bfc19a24558ada0a77f3f740dd2',
  Cottey: '12redirect21',
};

export const roles = {
  Support: '04a1d0a6f0884bcfb44911c2eaa5b77f',
  Finance: '21160e65fd7243c49023aad41be8b084',
  SPDOfficer: '2ed5b967133e41febd61998477e018bb',
  RMR: '6b128d199aa04f99b362cff974958550',
  Admin: '785238dd501e4544b3970f742b19b04a',
  LCOfficer: '81f985be6ef242018e17d574b3ab7c36',
  Executive: '8cf288415fa24a2b9a23ab768db43533',
  Communications: 'f8d3d9db43ca49aea716df742adffd02',
  Project: '8a47408f383c4aac9a8f2ba15195b191',
  Member: '17498438bae2433595431cc7f273a960',
};

export const presetDates = {
  custom: 'Custom Filter',
  today: 'Today',
  yesterday: 'Yesterday',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  lastMonth: 'Last Month',
  thisYear: 'This Membership Year',
  lastYear: 'Last Membership Year',
};

export const transferChapterStatuses = {
  Initial: '894013f6f9a24710b850736f07438594',
  Pending: '1ebfa8c4d1954633bfa29339833fdd8f',
  Visit: '8b54a13336c040f788d4b926a0c4f286',
  Removed: '6190df3b5f14416ca50a04c8ee443026',
  Transferred: '155a713f82854c07819a533a22ebe158',
};

export const addressTypes = {
  Address: 'e874793f23c2465ebea8bb1adcc26711',
  Seasonal: '2341d1a1aa2b49a5aacec458c2c8f7b2',
};

export const reciprocityTypes = {
  Reciprocity: '008cc3371f564c0ea313b9f043600dc7',
  Group: '080eda7b567c44538b22630db356e335',
};

export const eventType = {
  Meeting: 'da5cd21ac8784651a2c34806ca6f004a',
  Social: '385866c3ab5242ca96a11f70735467e5',
};

export const groupTypes = {
  Crafts: '07c0b865969447f19d891503171fef0e',
  Exercis: '0eef41a1f7b348c0a1ba727b1ed99b56',
  Dining: '0f441de7ddea4e388085a9c498bc0230',
  Wine: '1e906557fbd24d56897e3c7e6dc2f6a6',
  Book: '4f7d876f95824869a4fae85b7d2a05e3',
  Committee: '73aacd0565a847668d4a942470da55b8',
  Game: '931283f1ec324bc2a7d9f9ae22be007b',
  Coffee: 'b0723cf98e6744a39bba41fa7ffd6e69',
  Other: 'd9c65b103a064856be9408747d0ee734',
};

export const marketPlaceStatuses = {
  AwaitingApproval: '62e406a07b6344219838b850e382dab1',
  Approved: '241c0f5e47e24b62a6d1e257dcab0a01',
  Rejected: '963cbce3311a4dd4a81a15411145175e',
  Expired: '536d2019e36044c48827dcf4e6ca82c8',
  Removed: 'e46c4fb6746f452a86d13b5f7d304f37',
};

export const calculateDate = (preset) => {
  let startDate = new Date();
  let endDate = new Date();
  switch (preset) {
    case 'today':
      startDate = new Date();
      break;
    case 'yesterday':
      startDate = new Date(new Date().setDate(new Date().getDate() - 1));
      break;
    case 'thisWeek':
      startDate = new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay())
      );
      break;
    case 'thisMonth':
      startDate = new Date(new Date().setDate(1));
      break;
    case 'lastMonth':
      startDate = new Date(new Date().setMonth(new Date().getMonth() - 1, 1));
      break;
    case 'thisYear':
      // year start is actually March 1st - need to figure out if we are past that date
      // and if so keep the year the same otherwise go back a year
      if (new Date().getMonth() < 2) {
        startDate = new Date(
          new Date().setFullYear(new Date().getFullYear() - 1, 2, 1)
        );
      } else {
        startDate = new Date(
          new Date().setFullYear(new Date().getFullYear(), 2, 1)
        );
      }
      break;
    case 'lastYear':
      // year start is actually March 1st - need to figure out if we are past that date
      // and if so go back a year otherwise go back 2 years
      if (new Date().getMonth() < 2) {
        endDate = new Date(
          new Date().setFullYear(new Date().getFullYear() - 1, 2, 1)
        );
        startDate = new Date(
          new Date().setFullYear(new Date().getFullYear() - 2, 2, 1)
        );
      } else {
        endDate = new Date(
          new Date().setFullYear(new Date().getFullYear(), 2, 1)
        );
        startDate = new Date(
          new Date().setFullYear(new Date().getFullYear() - 1, 2, 1)
        );
      }
      break;
    default:
      break;
  }

  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
  };
};

export const getCalendarYearStart = () => {
  // Year start is actually March 1st - need to figure out if we are past that date
  const currentYear = new Date().getFullYear();
  if (new Date().getMonth() < 2) {
    return new Date(currentYear - 1, 2, 1); // March 1st of the previous year
  } else {
    return new Date(currentYear, 2, 1); // March 1st of the current year
  }
};

export const supportedReportFilters = [
  'spd_id',
  'chapter_id',
  'disbanded',
  'member_status',
  'inactive_start_date',
  'date_selector',
  'start_date',
  'end_date',
  'activity_type',
  'position_ids',
  'leadership_status',
  'is_living',
];

export const seekingTransfer = false;

export const test_frequecy = [
  {
    id: '566caf72c6ca40af8bb89e0dfe9e800f',
    name: 'Weekly',
  },
  {
    id: 'd912dc2c45054401a38daac314e7ae1c',
    name: 'Bi-Weekly',
  },
  {
    id: '8ab9371acaec45d7a3d72154f401dbd7',
    name: 'Monthly',
  },
];

export const days_of_week = [
  {
    id: '072cc0aabc844b7aad60c0e2437dda42',
    name: 'Sunday',
  },
  {
    id: 'ba44777b6720405392f2bfeae817d2cb',
    name: 'Monday',
  },
  {
    id: '8538aebaae4b4c9bbc23fdfb889ffc2a',
    name: 'Tuesday',
  },
  {
    id: '1802fa6bd2104dc3814ba4e9c659ba05',
    name: 'Wednesday',
  },
  {
    id: '08155763011e4dceaf3d65b9ef370af5',
    name: 'Thursday',
  },
  {
    id: '11d65c8ae2c74bd7abea06c5c3e9e625',
    name: 'Friday',
  },
  {
    id: 'f07ae738f0dc4b879dec61eb9d5bfe34',
    name: 'Saturday',
  },
];

export const times_of_day = [
  {
    id: '12:00',
    name: '12:00',
  },
  {
    id: '12:30',
    name: '12:30',
  },
  {
    id: '1:00',
    name: '1:00',
  },
  {
    id: '1:30',
    name: '1:30',
  },
  {
    id: '2:00',
    name: '2:00',
  },
  {
    id: '2:30',
    name: '2:30',
  },
  {
    id: '3:00',
    name: '3:00',
  },
  {
    id: '3:30',
    name: '3:30',
  },
  {
    id: '4:00',
    name: '4:00',
  },
  {
    id: '4:30',
    name: '4:30',
  },
  {
    id: '5:00',
    name: '5:00',
  },
  {
    id: '5:30',
    name: '5:30',
  },
  {
    id: '6:00',
    name: '6:00',
  },
  {
    id: '6:30',
    name: '6:30',
  },
  {
    id: '7:00',
    name: '7:00',
  },
  {
    id: '7:30',
    name: '7:30',
  },
  {
    id: '8:00',
    name: '8:00',
  },
  {
    id: '8:30',
    name: '8:30',
  },
  {
    id: '9:00',
    name: '9:00',
  },
  {
    id: '9:30',
    name: '9:30',
  },
  {
    id: '10:00',
    name: '10:00',
  },
  {
    id: '10:30',
    name: '10:30',
  },
  {
    id: '11:00',
    name: '11:00',
  },
  {
    id: '11:30',
    name: '11:30',
  },
];

export const months = [
  {
    id: '49f8bd874f1448eb8f4ec4153f5061c5',
    name: 'January',
  },
  {
    id: '1f9dc5e40df845e0b0a986abd7baefe0',
    name: 'February',
  },
  {
    id: 'bdb881b50e1a4393bdb863ed192f590d',
    name: 'March',
  },
  {
    id: '892e3a000fa94b9b8098513403a0a433',
    name: 'April',
  },
  {
    id: '2fb5b8dae5ef418c81b477d9fe122ee2',
    name: 'May',
  },
  {
    id: '8be492e9eb854922abc8609890535ab9',
    name: 'June',
  },
  {
    id: 'af8ba77828394d07a61e037ba88517a3',
    name: 'July',
  },
  {
    id: '7c1b6caedbaa4767bed246122fca25cb',
    name: 'August',
  },
  {
    id: '4236f50e18fc410e8924bf737d76eab8',
    name: 'September',
  },
  {
    id: 'c1a22ef2222842969eecda159d672b74',
    name: 'October',
  },
  {
    id: '10045ce54aaf484cb36e1810b0939b29',
    name: 'November',
  },
  {
    id: 'c9e23f562aa543e4bf2ae6a2e2801e9d',
    name: 'December',
  },
];

export const monthlyTimes = [
  {
    id: '3d9dde1499da482cadda1a503ae484de',
    name: '1st',
    type: 'monthly',
  },
  {
    id: '0d032d935b6d4e9e96b9d1567a0f09a2',
    name: '2nd',
    type: 'monthly',
  },
  {
    id: '443ef4bc156443d68e7305e38b8da7ee',
    name: '3rd',
    type: 'monthly',
  },
  {
    id: '4e4de181e76544df83bea7e522ef1583',
    name: '4th',
    type: 'monthly',
  },
  {
    id: '7e661dd663974b9892e1a750164cae98',
    name: '1st and 3rd',
    type: 'biweekly',
  },
  {
    id: '9f53145b0b3044ea9487d9538ab38df2',
    name: '2nd and 4th',
    type: 'biweekly',
  },
];

export const meetingFormats = [
  {
    id: 'befbf9d24f254882b678609c86880cf9',
    name: 'In-Person',
  },
  {
    id: 'd076e7db8e77473892263088e4f328cf',
    name: 'Virtual',
  },
  {
    id: '90aa631f3b714dd0b99c11593cf0af85',
    name: 'Hybrid',
  },
];

// Position ID Groups for Quick Filters
export const state_officers = [
  'fa95c0a7787a4e2ea0b744089b4a9067', // Organizer
  '95a28dcbe0d8440aa53598d004b200f3', // Secretary
  '5c14c4cf435246ebba0d01b5f2c8662c', // President
  '2374109b46b741d480f205bafafa4b34', // Treasurer
  'd52d09431928466abb5954f55704bd1d', // Vice President
];

export const assistants = [
  '7c398a0a88384651a1b8cb5afc7f554d', // Executive Treasurer
  'bc696b31f8cf4580ae334e34ec15ce06', // Executive Secretary / Treasurer
  '7977a58737614f32889ddb31c9dfdf08', // Executive Secretary
];

export const local_chapter_positions = [
  'ed2edb1a95264b99823d4d9053e074c4', // Chaplain
  '8de785ee95ba4e56b689872cdc84795c', // Corresponding Secretary
  'ad459744ae8543f587663e441d5ba0ac', // Guard
  '7d0bd56936ed4fc48b8fb33551dc243d', // Membership Chair
  '4e9b9a89581c4fb89dc3439609298da4', // President
  '021cda2333c04709910ff3b1731e2dba', // Recording Secretary
  '8af3dbe15eec4c7899ca1fb791a04bf4', // Technology Chair
  '337907494f974e79aa3d806cd3362be5', // Treasurer
  'bc44015f41294facb7cd7860a70088fd', // Vice President
];

export const local_project_chairs = [
  '3564f07653e241b3b1a521f4b1336c06', // Cottey College Chair
  '496b7d439e9f48f8b7156bcf6bc38fca', // ELF Chair
  'b4d7165dbbfa40f29832e27d2be9cec5', // IPS Chair
  '577188230a6a44a3bd727ba9581765f9', // PCE Chair
  '7e07ede168e24e4ebd95a7869c64c99e', // PSA Chair
  '5c565644a15a441a9a836a90ec8887dc', // STAR Chair
];

export const local_chapter_roster_dues_statuses = [
  {
    id: '4dd1112995f74575834ad8f337092a90',
    name: 'Local Chapter Treasurer',
    order: 1,
    color: '#D2042D', // Red
  },
  {
    id: 'acf1e4e4f87b44518b4f55097433ead4',
    name: 'Local Chapter President',
    order: 2,
    color: '#0072CE', // Blue
  },
  {
    id: '810b91c4f11a4301b551090bed547a4c',
    name: 'S/P/D Treasurer',
    order: 3,
    color: '#FF8C00', // Orange
  },
  {
    id: '1d6ebbdb98334816b6ace293463d9069',
    name: 'Local Chapter Completed',
    order: 4,
    color: '#00A859', // Green (completed)
  },
];

export const spd_roster_dues_statuses = [
  {
    id: '71e403ef15d04bc8b4872c44d43212ad',
    name: 'S/P/D Treasurer',
    order: 1,
    color: '#D2042D', // Red
  },
  {
    id: 'cff68e7737924ed29b636ac763fa72ee',
    name: 'S/P/D President',
    order: 2,
    color: '#0072CE', // Blue
  },
  {
    id: '612a5ef7baf940eea81f3d5b232c112f',
    name: 'Completed',
    order: 3,
    color: '#00A859', // Green (completed)
  },
];

export const irs_spd_statuses = [
  {
    id: 'f0249abe83b441b5ac536123065b46c0',
    name: 'S/P/D Treasurer',
    order: 1,
    color: '#D2042D', // Red
  },
  {
    id: '4baae6c18b0f42e8a6b0520f2eea0394',
    name: 'S/P/D President',
    order: 2,
    color: '#0072CE', // Blue
  },
  {
    id: '2e4d67bb2e98433487801163e4257363',
    name: 'Completed',
    order: 3,
    color: '#00A859', // Green (completed)
  },
];

export const irs_lc_statuses = [
  {
    id: 'a21f7257bb00430da43f57a9d61baa90',
    name: 'Local Chapter Treasurer',
    order: 1,
    color: '#D2042D', // Red
  },
  {
    id: '672d64ebcaee49afbb9ddf65930e1668',
    name: 'Local Chapter President',
    order: 2,
    color: '#0072CE', // Blue
  },
  {
    id: 'ca04d784695d4225a749aadfa3adb651',
    name: 'S/P/D Treasurer',
    order: 3,
    color: '#FF8C00', // Orange
  },
  {
    id: '4c53f74ba630408ca28f475dc18ebfc8',
    name: 'Completed',
    order: 4,
    color: '#00A859', // Green (completed)
  },
];

export const irs_reciprocity_statuses = [
  {
    id: 'd2c5f29fb08a4282ad4bad6cc4cb6bb2',
    name: 'Reciprocity Treasurer',
    order: 1,
    color: '#D2042D', // Red
  },
  {
    id: '3898f31551b840dca7fb24b951c06779',
    name: 'Reciprocity President',
    order: 2,
    color: '#0072CE', // Blue
  },
  {
    id: 'c3c5171a352c4822971658e6d2bb1bb2',
    name: 'Completed',
    order: 3,
    color: '#00A859', // Green (completed)
  },
];

// Map form types to their status arrays
export const formTypeToStatusArrayMap = {
  // IRS Forms
  irs_lc: irs_lc_statuses,
  irs_sc: irs_spd_statuses,
  irs_rg: irs_reciprocity_statuses,
  // Roster Dues
  roster_lc: local_chapter_roster_dues_statuses,
  roster_spd: spd_roster_dues_statuses,
};
